$.fn.setBoxShadow = function (settings) {
  return this.each(function () {
    const elem = $(this);
    elem.css("box-shadow", settings);
    elem.css("-webkit-box-shadow", settings);
    return elem.css("-moz-box-shadow", settings);
  });
};
